<template>
    <div class="container">
        <div class="mian">
            <div class="topDiv">
                <span class="topDiv_span">{{year}}年{{month}}月{{day}}日</span>
            </div>

            <div class="body_item">
                <div class="body_item_left">
                    <span class="body_item_left_span1">*</span>
                    <span v-if="canEditAll" class="body_item_left_span2">总销售额(元)</span>
                    <div v-else class="body_item_left_div1" >
                        <span class="body_item_left_span3">总销售额(元)</span>
                        <span class="body_item_left_span4">以下计算总额</span>
                    </div>
                    <!-- v-on:input="handleInput2" -->
                    <input v-if="canEditAll" class="body_item_left_input" type="number"
                        v-on:input="handleInput2"
                        placeholder="请输入"   @keydown="handleInput2" v-model.number="details.revenueTotal" />
                    <span  v-else class="body_item_left_span5">{{details.revenueTotal}}</span>

                </div>
                <div class="body_item_right" v-if="!showList" @click="showListAction(true)">
                    <span class="body_item_right_span" >切换明细输入</span>
                    <img class="body_item_right_icon" src="../../assets/images/icon_arrows_down.png"/>
                </div>
                <div class="body_item_right" v-else @click="showListAction(false)">
                    <span class="body_item_right_span" >退出明细输入</span>
                    <img class="body_item_right_icon" src="../../assets/images/icon_arrows_up.png"/>
                </div>
            </div>

            <div class="list" v-if="showList" >
                <!-- <scroll  :pullup="false" :pulldown="false" :scrollX="true" > -->
                    <section class="cell" v-for="(item,index) in dataList" :key="index" >
                        <div class="cell_item">
                            <span class="cell_item_span1">{{item.paymentMethodName}}</span>
                            <div class="cell_item_right">
                                <!--  -->
                                <input @input="changeRevenue" @change="changeRevenue"  class="cell_item_right_input" type="number"
                                  v-on:input="handleInput2"
                                  @keydown="handleInput2"  placeholder="请输入" v-model.number="item.revenue" @blur="outblur" />
                                <span class="cell_item_span2">元</span>

                            </div>
                        </div>
                        <div v-if="index!=(dataList.length-1)" class="cell_line"></div>
                    </section>
                <!-- </scroll> -->

            </div>

            <div class="bishuBody">
                <span class="bishuBody_span1">笔数</span>
                <span class="bishuBody_span2">(选填)</span>
                <input  class="bishuBody_input" type="number"
                        placeholder="请输入" v-model.number="details.dayCount" @input="details.dayCount = Number($event.target.value.replace(/\D+/, ''))" />

            </div>

        </div>

        <div class="footer_box button" >
            <mt-button v-if="isPostIng==false" class="p btn_default" @click="postData">完成</mt-button>
            <mt-button v-else class="p btn_default" >完成</mt-button>
        </div>

    </div>
</template>

<script>
import { saveRevenue,getRevenueDetail } from "../../utils/api";
import Scroll from "../../components/scroll";
import util from "../../utils/util";
import { mapState } from 'vuex';
export default {
  name: "billDetail",
  components: {
     Scroll,
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  filters: {
    checkMath(val){
      return val?val.split('-')[1]:'';
    }
  },
  data() {
    return {
      activeTab: 1,
      result:'', //合同数组
      canEditAll:false,   //总额是否可编辑
      showList:false,
      allAmount:'',// 总额
      details:'',
      dataList: [],
      allLoaded:true,
      isLoaded:false,
      contId:'',
      year:'',
      month:'',
      day:'',
      isPostIng:false,

    }
  },
  created(){
      //合同id：contId；年：year；月：month；日：day
      let query = this.$route.query;
      this.contId=query.contId;
      this.year=query.year;
      this.month=query.month;
      this.day=query.day;
      this.getRevenueDetail();
  },


    methods: {
        handleInput2(e) {
            // 通过正则过滤小数点后两位
           // e.target.value=e.target.value.replace(/[^\d]/g,'');
            e.target.value = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null
        },

       getRevenueDetail(){
            let params = {
                userId: this.common.userId,
                //   yearMonth: this.year,
                year:String(this.year) ,
                month:String(this.month),
                day:String(this.day),
                contId: this.contId,
                // companyId:this.common.userTenantInfo.companyId
            }
            getRevenueDetail(params).then(ret => {
                console.log(ret)
                if (ret.res.code === 10000) {
                    this.details = ret.body
                    this.dataList =ret.body.rveRevenueItemVoList;
                    var num=0;
                    for(var i=0;i<this.dataList.length;i++){
                        var item = this.dataList[i];
                        var s= 0;
                        if(item.revenue){
                            s= parseFloat(item.revenue);
                        }
                        num=num+s;
                    }
                    if(num==0){
                        this.canEditAll =true;
                    }else{
                        this.canEditAll =false;
                    }

                } else {
                    //toast.showMessage(ret.res.msg)
                }
            })
       },

        //上拉
            loadup(){
            //  console.log("in loadup");
            //  if(this.isLoding){
            //    return;
            //  }
            //  if(this.allLoaded){
            //    return;
            //  }
            //  this.pageNo=this.pageNo+1;
            //  this.getNoticeListAction();
            },

            //下拉刷新
            loadData(){
            //  if(this.isLoding){
            //    return;
            //  }
            //  this.pageNo=1;
            //  this.allLoaded =false;
            //  this.getNoticeListAction();
            },

            showListAction(b){
                console.log("in showListAction")
                this.showList=b;
            },


            outblur(){
                // var num=0;
                // for(var i=0;i<this.dataList.length;i++){
                //     var item = this.dataList[i];
                //     var s= 0;
                //     if(item.revenue){
                //         s= parseFloat(item.revenue);
                //     }
                //     num=num+s;
                // }
                // this.details.revenueTotal=num;
            },
            changeRevenue(){
                var num=0;
                for(var i=0;i<this.dataList.length;i++){
                    var item = this.dataList[i];
                    var s= 0;
                    if(item.revenue){
                        s= parseFloat(item.revenue);
                    }
                    num=num+s;
                }
                this.details.revenueTotal=String(num.toFixed(2));
                if(num==0){
                    this.canEditAll =true;
                }else{
                    this.canEditAll =false;
                }

            },

            postData(){
                if(this.isPostIng){
                    return;
                }
                this.isPostIng=true;
                var params =this.details;
                if(!params.revenueTotal){
                    util.showToast("请输入金额")
                    this.isPostIng=false;
                    return;
                }
                var r = parseFloat(params.revenueTotal);
                if(r==0){
                    util.showToast("总销售金额不能为0")
                    this.isPostIng=false;
                    return;
                }
                var list = this.dataList;
                for(var i=0;i<list.length;i++){
                    var item =list[i];
                    if(item.revenue){
                        item.revenue =String(item.revenue); ////转string
                    }
                }
                params.rveRevenueItemVoList =list;
                params.revenueTotal=String(this.details.revenueTotal); //转string
                params.contId=this.contId;
                if(!params.dayCount){
                    params.dayCount='1';
                }
                params.dayCount =String(params.dayCount); ////转string

                saveRevenue(params).then(ret => {
                    console.log(ret)

                    util.showToast(ret.res.msg)
                    if (ret.res.code === 10000) {
                        setTimeout(() => {
                            this.$router.go(-1);
                            this.isPostIng=false;
                        }, 1000);
                    } else {
                         this.isPostIng=false;
                        //toast.showMessage(ret.res.msg)
                    }
                })

            }
    }

}

</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
//   height: 100vh;
  background-color: #EDEDED;
  .flex(column);
  .shop_list1 {
    // flex: 1;
    //  height: 500px;
  }
}
.mian{
    flex: 1;
    margin-bottom: 108px;
    flex-direction:column;
}

.topDiv{
    width: 100%;
    height: 88px;
    flex-direction: row;
    background:#EDEDED;
    display: flex;
    align-items: center;
}
.topDiv_span{
    margin-left: 40px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}

.body_item{
    width: 100%;
    height:100px;
    background:rgba(255,255,255,1);
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.body_item_left{
    height:100px;
    margin-left: 20px;
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: flex-start;

}

.body_item_left_span1{

    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(252,63,86,1);
    line-height:40px;

}
.body_item_left_span2{
    margin-left: 4px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;

}

.body_item_left_div1{
    display: flex;
    margin-left: 4px;
    width: 180px;
    height:100px;
    flex-direction: column;
}

.body_item_left_span3{
    margin-top: 10px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.body_item_left_span4{
    height:34px;
    font-size:24px;
    font-weight:400;
    color:rgba(253,152,56,1);
    line-height:34px;
}
.body_item_left_span5{
    margin-left: 20px;
    width: 250px;
    height:50px;
    font-size:36px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:50px;
}

.body_item_left_input{
    margin-left: 40px;
    width: 250px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:#333333;
    line-height:40px;
}

.body_item_right{
    display: flex;
    height:100px;
    margin-right: 36px;
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: flex-end;


}

.body_item_right_span{
    height:34px;
    font-size:24px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:34px;
    margin-right: 8px;
}
.body_item_right_icon{
    width: 24px;
    height: 24px;
}
//list
.cell{
     width: 100%;
     flex-direction: column;
     background:rgba(248,248,248,1);
     display: flex;
}
.cell_item{
    width: 100%;
    height:88px;
    flex-direction:row;
    display: flex;
    align-items: center;
    justify-content: space-between;

}
.cell_item_span1{
    margin-left: 40px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.cell_item_right{
     display: flex;
    height:88px;
    margin-right: 40px;
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: flex-end;

}

.cell_item_right_input{
    text-align: right;
    width: 300px;
    height:40px;
    font-size:28px;
    background-color:rgba(248,248,248,1);
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}

.cell_item_span2{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}

.cell_line{
    margin-left: 40px;
    margin-right: 40px;
    display: flex;
    height:2px;
    background:rgba(234,234,234,1);
}
//笔数
.bishuBody{
    margin-top: 14px;
    margin-bottom: 14px;
    display: flex;
    width:100%;
    height:100px;
    background:rgba(255,255,255,1);
    align-items: center;
    justify-content: flex-start;
}

.bishuBody_span1{
    margin-left: 40px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.bishuBody_span2{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:#999999;
    line-height:40px;
}
.bishuBody_input{
    margin-left: 68px;
     display: flex;
    width: 300px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:#333333;
    line-height:40px;
}

//foot
.footer_box{
  position:fixed;
  bottom:0;left:0;right:0;height:108px;
  background:#f3f4f6;
  padding:16px 28px;
  z-index:100;
  box-sizing: border-box;
  .p{
    height:76px;
    width:100%;
    background:@color17;
    border-radius:4px;
    text-align:center;
    line-height:76px;
    color:#fff;
    font-size:32px;
  }
}

</style>